import { z } from 'zod';
import { BaseFieldDefinitionSchema } from './base';
export var RichTextFieldDefinition;
(function (RichTextFieldDefinition) {
    RichTextFieldDefinition.TYPE = 'richText';
})(RichTextFieldDefinition || (RichTextFieldDefinition = {}));
export const RichTextFieldDefinitionSchema = BaseFieldDefinitionSchema.and(z.object({
    type: z.literal(RichTextFieldDefinition.TYPE),
    i18n: z.boolean().optional()
}));
//# sourceMappingURL=richtext.js.map